var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgSearchIconClose(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#282828",
    d: "M12.7 0L14 1.304 8.302 7 14 12.696 12.7 14 7 8.302 1.3 14 0 12.696 5.698 7 0 1.304 1.3 0 7 5.698 12.7 0z",
    fillRule: "evenodd"
  })));
}

export default __webpack_public_path__ + "f27005efdfd58980b98abd8255375d55.svg";
export { SvgSearchIconClose as ReactComponent };